import _ from 'lodash';

const Debug = false;

function logMessage(msg:string, obj:any|null=null) {
  if (Debug) {
    const key = `${window.location.pathname}${window.location.search}`;
    //window.console.log(`Screen storeage: ${key}`);
    //window.console.log(msg);
    if (obj) {
      //window.console.log(obj);
    }
  }
}
// function customizer(objValue, srcValue) {
//   if (_.isArray(objValue)) {
//     return srcValue;
//   }
// }

interface IndexByAny {
  [key: string]: any,
};

const ScreenMemory:IndexByAny = {
};

export function getScreenMemory() {
  const key = `${window.location.pathname}${window.location.search}`;
  if (!ScreenMemory[key]) {
    logMessage('Not found. returning default memory object');
    return {};
  }

  return ScreenMemory[key];
}

export function storeInScreenMemory(obj:any) {
  if (_.isEmpty(obj)) {
    logMessage('Storing empty object is no-op');
    return getScreenMemory();
  }

  // let screenMemory = getScreenMemory();
  // screenMemory = _.mergeWith(screenMemory, obj, customizer);
  const screenMemory = {
    ...getScreenMemory(),
    ...obj,
  };

  const key = `${window.location.pathname}${window.location.search}`;
  ScreenMemory[key] = screenMemory;

  logMessage('Stored in screen memory ->', screenMemory);

  return screenMemory;
}

export function purgeScreenFromMemory(urls:Array<string>) {
  if (!urls) {
    return;
  }

  urls.forEach(u => {
    if (ScreenMemory[u]) {
      logMessage('purge ', u);
      delete ScreenMemory[u];
    }
  });
}
